import React, {Fragment} from 'react';

const AppLoading = () => {
    return <Fragment>
        Loading
    </Fragment>
};

export default AppLoading;
